import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-163f1a5a")

_pushScopeId("data-v-163f1a5a")
const _hoisted_1 = { class: "mobile-dragon-tiger-bet-view-root" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_mobile_bet_area = _resolveComponent("mobile-bet-area")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_mobile_bet_area, {
      class: "area",
      betRatio: '1:1',
      betType: 5,
      tempAmount: _ctx.redTemp,
      confirmedAMount: _ctx.redFinal,
      currentIndex: _ctx.selectedBetArea,
      allowBet: _ctx.allowBet,
      onPlaceBet: _ctx.OnPlaceBet,
      onCancelBet: _ctx.OnCancelBetTemp,
      onOnConfirmBet: _ctx.OnConfirmBet,
      chipValue: _ctx.chipValue,
      showFlash: _ctx.isRed,
      showConfirmCancelButton: false
    }, null, 8, ["tempAmount", "confirmedAMount", "currentIndex", "allowBet", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "chipValue", "showFlash"]),
    _createVNode(_component_mobile_bet_area, {
      class: "area",
      betRatio: '1:10',
      betType: 3,
      tempAmount: _ctx.greenTemp,
      confirmedAMount: _ctx.greenFinal,
      currentIndex: _ctx.selectedBetArea,
      allowBet: _ctx.allowBet,
      onPlaceBet: _ctx.OnPlaceBet,
      onCancelBet: _ctx.OnCancelBetTemp,
      onOnConfirmBet: _ctx.OnConfirmBet,
      chipValue: _ctx.chipValue,
      showFlash: _ctx.isGreen,
      showConfirmCancelButton: false
    }, null, 8, ["tempAmount", "confirmedAMount", "currentIndex", "allowBet", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "chipValue", "showFlash"]),
    _createVNode(_component_mobile_bet_area, {
      betRatio: '1:1',
      class: "area",
      betType: 4,
      tempAmount: _ctx.blueTemp,
      confirmedAMount: _ctx.blueFinal,
      currentIndex: _ctx.selectedBetArea,
      allowBet: _ctx.allowBet,
      onPlaceBet: _ctx.OnPlaceBet,
      onCancelBet: _ctx.OnCancelBetTemp,
      onOnConfirmBet: _ctx.OnConfirmBet,
      chipValue: _ctx.chipValue,
      showFlash: _ctx.isBlue,
      showConfirmCancelButton: false
    }, null, 8, ["tempAmount", "confirmedAMount", "currentIndex", "allowBet", "onPlaceBet", "onCancelBet", "onOnConfirmBet", "chipValue", "showFlash"])
  ]))
})